<template>
    <div>
        <PageHeader :page="page" :template="'2'" @action="createNew" v-if="!state.loading"/>
        <div class="" v-if="!state.loading">
            <DataTable :tableData="tableData" @cancel="cancelSub" @resume="resume"/>
        </div>
        <div class="temp-row" v-if="state.loading" style="text-align: center;">
            <img src="@/assets/img/ajldr.gif" style="width:100px"/>
        </div>
    </div>

    <ModalView
        :isVisible="state.CreateModal"
        :fixclose="true"
        @close="state.CreateModal = false">
        
        <DynamicForm :columns="1"
            :fields="newFields" @submit="subscribe"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView> 
</template>
<script>
import icons from '@/assets/js/icons.js';
import { reactive, ref, onMounted, computed} from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import DynamicForm from '@/components/DynamicForm.vue';
import { useRoute } from 'vue-router';
import DataTable from '@/components/DataTable.vue';
import { usePermissions } from '@/composables/usePermissions';
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import ModalView from '@/components/ModalView.vue';
export default{
    name:"SubscriptionHistory",
    components:{PageHeader,DataTable,ModalView,DynamicForm},
    setup(){
        const { hasPermission } = usePermissions();
        const state=reactive({CreateModal:false, submitting:false, errors:[],
            success:false
        })
        const route = useRoute();
        const packages=ref([])
        const cus_id = computed(() => route.params.customerId)
        const page=ref({title:"Subscription List", btn:"Add new",
        desc:"Manage all Subscription  with ease. "})
        var action_label=[],
        action=[]

        if(!hasPermission('Subscription', 'create')){
            page.value.btn="";
        }

        if(hasPermission('Subscription', 'edit')){
            action_label.push(icons.cancel)
            action.push("cancel")
            action_label.push(icons.subscription)
            action.push("resume");
        }

        const tableData = ref({
            rows: [],
            loading: true,
            columns: [
                { label: "Name" },
                { label: "Amount" },
                { label: "Starts" },
                { label: "Expires" },
                { label: "Registered By" }
            ],
            options:{
                label:"Action",
                action_label:action_label,
                action:action
            },
            total:0
        });

        const newFields=ref([
            { name: "Subscription", number: "2",data:
                [
                    { type: 'select', name: 'package', label: "Subscription",
                    value: "",options:packages  },
                    { type: 'text', name: 'deposit', label: "Deposit",
                    value: "" },
                    { type: 'date', name: 'date', label: "Start Date",
                    value: "" },
                    {type:'hidden', name:"cus_id", value:cus_id.value}

                ]
            }
        ])

        function setTable(msg){
            var data={}
            tableData.value.loading = false;
            tableData.value.rows.length=0
            Object.keys(msg).forEach(set => {
                data={id:msg[set].id,status:msg[set].status};
                var v=[];
                Object.keys(msg[set].val).forEach(row => {
                v.push(msg[set].val[row])
                });
                data.val=v;
                tableData.value.rows.push(data)
            });
            tableData.value.total=tableData.value.rows.length
        }

        function setErrors(res){
            var errors=[];
            Object.keys(res.msg).forEach(key => {
            var e=res.msg[key],er="";
            Object.keys(e).forEach(k => {
                er+=er=="" ? e[k] : ", "+e[k]
            })
            errors.push(er);
            });
            state.errors=errors;
        }

        function subscribe(data){
            state.submitting=true;
            state.errors=[];
            data.subscribe="";
            call({
                url:urls.customer,
                data:data,
                success:(res)=>{
                state.submitting=false;
                if(res.status){
                    state.success=true;
                    var d=res.msg;
                    setTable(d);
                }else{
                    setErrors(res)
                }
                }
            })
        }

        onMounted(() => {
            call({
                url:urls.customer,
                data:{startSubHistory:cus_id.value},
                success:(res)=>{
                state.loading=false
                    if(res.status){
                        var d=res.msg;
                        packages.value=[];
                            Object.keys(d.packages).forEach(k => {
                            packages.value.push(d.packages[k])
                        })
                        setTable(d.history);
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });
        
        function createNew(){
            state.success=false;
            state.error=[]
            state.CreateModal=true;
        }

        function cancelSub(i){
            tableData.value.loading = true;
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{cancelSub:id},
                success:(res)=>{
                state.loading=false
                    if(res.status){
                        var d=res.msg;
                        setTable(d);
                    }else{
                        tableData.value.loading = false;
                        alert(res.msg);
                    }
                }
            })
        }

        function resume(i){
            tableData.value.loading = true;
            var id=tableData.value.rows[i].id
            call({
                url:urls.customer,
                data:{resumeSub:id},
                success:(res)=>{
                state.loading=false
                    if(res.status){
                        var d=res.msg;
                        setTable(d);
                    }else{
                        tableData.value.loading = false;
                        alert(res.msg);
                    }
                }
            })
        }

        return{state,page,tableData,newFields,subscribe,createNew,cancelSub,resume

        }
    }
}
</script>